import { useState } from 'react';

import { GameBar } from '../game-bar/ui/GameBar';
import { Navbar } from '../navbar/ui';

export const BottomBar = () => {
  const [hasNavbar, setHasNavbar] = useState(true);

  // TODO: refactor
  const checkHasNavbar = (value: boolean) => setHasNavbar(value);

  const hasGameBar = hasNavbar;

  return (
    <>
      {hasGameBar && <GameBar />}
      <Navbar checkHasNavbar={checkHasNavbar} />
    </>
  );
};
